/**
 * Normalisation des codes langue UI (préserve nl-BE / nl-NL).
 */
import { AVAILABLE_LANGUAGES, type LanguageCode } from './i18n';
import { normalizeDutchRegionalCode } from './dutchLocale';

const VALID = new Set<string>(AVAILABLE_LANGUAGES.map((l) => l.code));

export function normalizeLanguageCode(value: string | undefined | null): LanguageCode | null {
  if (!value) return null;
  const trimmed = value.trim().replace('_', '-');
  if (VALID.has(trimmed)) return trimmed as LanguageCode;

  const dutch = normalizeDutchRegionalCode(trimmed);
  if (dutch && VALID.has(dutch)) return dutch as LanguageCode;

  const base = trimmed.split('-')[0];
  if (VALID.has(base)) return base as LanguageCode;

  return null;
}

/** Affichage settings : match exact puis fallback base (ex. nl-BE). */
export function resolveAvailableLanguageCode(
  i18nLanguage: string | undefined | null
): LanguageCode {
  const normalized = normalizeLanguageCode(i18nLanguage);
  if (normalized) return normalized;
  return 'fr';
}
